module.exports = __webpack_public_path__ + "static/media/CertificateTeltonika.d5320b67.png";